import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal } from "@/components/site/Reveal";
import { INDUSTRIES } from "@/data/content";

export default function Industries() {
  const [active, setActive] = useState(0);

  return (
    <section
      className="relative border-t border-white/10 bg-[#0c0c0c] py-24 md:py-40"
      data-testid="industries-section"
    >
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <Reveal>
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#0033ff]">
            06 — Sectors
          </span>
          <h2 className="mt-6 max-w-3xl font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-tighter text-[#f4f4f5] md:text-6xl lg:text-7xl">
            Industries we connect.
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-10 lg:grid-cols-12">
          {/* rows */}
          <div className="border-t border-white/10 lg:col-span-7">
            {INDUSTRIES.map((ind, i) => (
              <button
                key={ind.no}
                onMouseEnter={() => setActive(i)}
                onFocus={() => setActive(i)}
                onClick={() => setActive(i)}
                data-testid={`industry-${ind.no}`}
                className={`group block w-full border-b border-white/10 py-8 text-left transition-colors duration-500 ${
                  active === i ? "bg-white/[0.03]" : ""
                }`}
              >
                <div className="flex items-baseline gap-6">
                  <span
                    className={`font-mono text-xs transition-colors ${
                      active === i ? "text-[#0033ff]" : "text-[#52525b]"
                    }`}
                  >
                    {ind.no}
                  </span>
                  <h3
                    className={`font-display text-3xl font-extrabold uppercase tracking-tight transition-colors md:text-5xl ${
                      active === i ? "text-[#f4f4f5]" : "text-[#52525b]"
                    }`}
                  >
                    {ind.name}
                  </h3>
                </div>
                <AnimatePresence>
                  {active === i && (
                    <motion.p
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4 }}
                      className="ml-[3.25rem] max-w-lg overflow-hidden font-mono text-sm leading-relaxed text-[#a1a1aa]"
                    >
                      <span className="block pt-4">{ind.body}</span>
                    </motion.p>
                  )}
                </AnimatePresence>
              </button>
            ))}
          </div>

          {/* image */}
          <div className="lg:col-span-5">
            <div className="relative aspect-[4/5] w-full overflow-hidden border border-white/10">
              <AnimatePresence mode="wait">
                <motion.img
                  key={active}
                  src={INDUSTRIES[active].image}
                  alt={INDUSTRIES[active].name}
                  initial={{ opacity: 0, scale: 1.08 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.7, ease: [0.76, 0, 0.24, 1] }}
                  className="absolute inset-0 h-full w-full object-cover grayscale contrast-125"
                />
              </AnimatePresence>
              <div className="absolute inset-0 bg-[#0033ff]/10 mix-blend-color" />
              <div className="pointer-events-none absolute inset-0 border border-white/10" />
              <span className="absolute bottom-4 left-4 font-mono text-[10px] uppercase tracking-[0.2em] text-white">
                / {INDUSTRIES[active].name}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
